import { Box, Theme, withStyles } from "@material-ui/core";

export const Content = withStyles((theme: Theme) => ({
  root: {
    overflowY: "auto",
    height: "calc(100vh - 80px)",
    padding: `${theme.spacing(2)}px ${theme.spacing(2)}px`,
    backgroundColor: theme.palette.background.default,
  },
}))(Box);
